export const copyToClipboard = (text) => {
  const el = document.createElement("textarea");
  el.className = "ctf-fb-cp-clpboard";
  el.value = text;
  document.body.appendChild(el);
  el.select();
  document.execCommand("copy");
  document.body.removeChild(el);
  return Promise.resolve(true);
};

export const loadAsset = (path) => {
  let assetURL = window.sby_settings.assetsURL;
  if (process.env.NODE_ENV === "development") {
    assetURL = "http://localhost:3000";
  }
  return `${assetURL}${path}`;
};

export const exportStringToFile = (
  content,
  filename,
  type = "application/json"
) => {
  const element = document.createElement("a");
  const file = new Blob([content], {
    type,
  });
  element.href = URL.createObjectURL(file);
  element.download = filename;
  document.body.appendChild(element);
  element.click();
};
